var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoutWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "noun_Log_Out_2718327",
    "data-name": "noun_Log Out_2718327",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.995,
    height: 20,
    viewBox: "0 0 20.995 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Log_Out",
    "data-name": "Log Out",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M9,16v5a1,1,0,0,0,1,1H22a1,1,0,0,0,1-1V3a1,1,0,0,0-1-1H10A1,1,0,0,0,9,3V8a1,1,0,0,0,2,0V4H21V20H11V16a1,1,0,0,0-2,0Zm-6.92-3.62a1.034,1.034,0,0,1,.21-1.09l3.54-3.53a1,1,0,0,1,1.41,1.41L5.405,11H16a1,1,0,1,1,0,2H5.405l1.83,1.83a1,1,0,1,1-1.41,1.41l-3.54-3.53A1,1,0,0,1,2.075,12.38Z",
    transform: "translate(-2 -2)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutWhite);
export default __webpack_public_path__ + "static/media/logout-white.09099be39bd865edc919784e2cfbe197.svg";
export { ForwardRef as ReactComponent };